export const plLocale = {
	months: [
		"Styczeń",
		"Luty",
		"Marzec",
		"Kwiecień",
		"Maj",
		"Czerwiec",
		"Lipiec",
		"Sierpień",
		"Wrzesień",
		"Październik",
		"Listopad",
		"Grudzień",
	],
	monthsShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
	weekdays: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
	weekdaysShort: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
	weekdaysMin: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
	longDateFormat: {
		LT: "HH:mm",
		LTS: "HH:mm:ss",
		L: "DD.MM.YYYY",
		LL: "D MMMM YYYY",
		LLL: "D MMMM YYYY HH:mm",
		LLLL: "dddd, D MMMM YYYY HH:mm",
	},
	calendar: {
		sameDay: "[Dzisiaj o] LT",
		sameElse: "L",
		nextDay: "[Jutro o] LT",
		nextWeek: "dddd [o] LT",
		lastDay: "[Wczoraj o] LT",
		lastWeek: "[W zeszły] dddd [o] LT",
	},
	relativeTime: {
		future: "za %s",
		past: "%s temu",
		s: "kilka sekund",
		ss: "%d sekund",
		m: "minuta",
		mm: "%d minut",
		h: "godzina",
		hh: "%d godzin",
		d: "dzień",
		dd: "%d dni",
		M: "miesiąc",
		MM: "%d miesięcy",
		y: "rok",
		yy: "%d lat",
	},
	dayOfMonthOrdinalParse: /\d{1,2}\./,
	ordinal: (n: number) => `${n}.`,
	week: {
		dow: 1, // Poniedziałek jest pierwszym dniem tygodnia.
		doy: 4, // Tydzień zawierający 4 stycznia jest pierwszym tygodniem roku.
	},
};
